var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 82.463,
  height: 77.708,
  viewBox: "0 0 82.463 77.708"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.749,74.221,51.619,20.672a12.081,12.081,0,0,0-20.776,0L1.715,74.221A12.074,12.074,0,0,0,12.1,92.467H70.362A12.076,12.076,0,0,0,80.749,74.221ZM41.231,82.8a4.832,4.832,0,1,1,4.832-4.832A4.838,4.838,0,0,1,41.231,82.8Zm4.832-19.327a4.832,4.832,0,0,1-9.664,0V39.318a4.832,4.832,0,0,1,9.664,0Z",
  transform: "translate(0 -14.759)",
  fill: "#ffde33"
}))));
export default __webpack_public_path__ + "static/media/wire-transfer-success.b54f4b66.svg";
export { SvgComponent as ReactComponent };